export const defaultFormDataTerrain = {
  additionalComments: '',
  adresse: '',
  terrainType: '',
  terrainSlope: '',
  surfaceRange: [100, 500],
  viabilise: false,
  budgetRange: [50000, 300000],
  purchaseDate: '',
  nom: '',
  prenom: '',
  dateNaissance: '',
  telephone: '',
  email: '',
  neighborhoodType: '',
  neighborProximity: false,
  restrictions: '',
  distanceToUrbanCenter: 0,
  vegetation: false,
  pointEau: false,
  proximityBigCity: '',
  // proximitySea: '',
  proximityMountains: '',
  publicMerProximity: '',
  viewSea: false,
  viewMountains: false,
  viewCity: false,
  viewCompagne: false,
  otherViewPreferences: '',
  transports: false,
  schools: false,
  shops: false,
  healthServices: false,
  recreation: false,
  familyComposition:'',
};

// // Define Yup validation schemas
// export const validationSchemaTerrain = Yup.object().shape({
//   nom: Yup.string().required('Nom is required'),
//   prenom: Yup.string().required('Prénom is required'),
//   email: Yup.string().email('Invalid email').required('Email is required'),

// });
